import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { RADIUS } from '@backrs_ui/common-ui/src/designSystem/spacing/spacing';

import { Box, SxProps, Theme } from '@mui/material';

import { AppIcon } from '../designSystem/icons/AppIcon';

export const BadgeCircle = () => {
  return (
    <Box sx={iconContainerSx}>
      <AppIcon iconName="Circle" diameter="8px" color="Blue/500" fill="Brand/500" />
    </Box>
  );
};

const iconContainerSx: SxProps<Theme> = {
  borderRadius: RADIUS['radius-full'],
  border: `2px solid ${COLOR_TOKENS['Brand/200']}`,
  width: '12px',
  height: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
};
